// Widget scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetExplore from './js/widgets/cardWidgetExplore.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import { facebookfeed, instafeed } from './js/widgets/socialNetworkWidget.js';
import cardWidgetHomepageBackground from './js/widgets/cardWidgetHomepageBackground.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetSEO from './js/widgets/cardWidgetSEO.js';
import cardWidgetFooterBackground from './js/widgets/cardWidgetFooterBackground.js';
import cardWidgetSubpageThemeBackgrounds from './js/widgets/cardWidgetSubpageThemeBackgrounds.js';
import cardWidgetJumpToVenue from './js/widgets/cardWidgetJumpToVenue.js';

// subpage widgets 

import fairRodeoButtons from './js/widgets/fairRodeoButtons.js';
import fairRodeoSwiper from './js/widgets/fairRodeoSwiper.js';
import interstateSwiper from './js/widgets/interstateSwiper.js';
import insterstateButtons from './js/widgets/insterstateButtons.js';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();   
    cardWidgetExplore();
    cardWidgetHomepageBackground();
    multiScheduleFeature();
    facebookfeed(true);
    instafeed();
    cssSponsors();
    fairRodeoButtons(); 
    insterstateButtons();
  });
}

// Initialize site-wide widgets
$(document).ready(function() {
  cardWidgetSubpageThemeBackgrounds();
  cardWidgetJumpToVenue();
  cardWidgetSEO();
  cardWidgetFooterBackground();
  fairRodeoButtons();
  insterstateButtons();
  if ($('body').hasClass('subpage-theme--fair-rodeo')) {
    fairRodeoSwiper();  
  }
  if ($('body').hasClass('subpage-theme--first-interstate')) {
    fairRodeoSwiper();      
  interstateSwiper();
  }
});
